import type { $Fetch } from 'nitropack';
import type { ProductTeaser } from '~/components/Product/types/product';
import type { BFFResponse } from '~/types/BFFResponse';

export interface RecoResponse {
  homepage_personalized: Pagination;
  product_detail: Pagination;
  product_detail_complements: Pagination;
}

interface Pagination {
  count: number;
  offset: number;
  current: number;
  items: ProductTeaser[];
}

export default ($fetch: $Fetch) => {
  const getRecommendations = async (body: unknown, { userId, type, productId }: { userId: string | undefined; type: string; productId: string | null | undefined }) => $fetch<BFFResponse<RecoResponse>>('/recommend', { method: 'POST', body: {
    data: body,
    userId,
    type,
    productId,
  },
  });

  return {
    getRecommendations,
  };
};
